export class ReceiptModel {
    public isChecked?: boolean;
    public id?: number;
    public uId?: number;
    public userName?: string;
    public status?: number;
    public statusDetail?: any;
    public receiver?: string;
    public address?: string;
    public phone?: string;
    public numberOfPack?: number;
    public weight?: number;
    public volume?: number;
    public shippingMethod?: string;
    public vnStoreID?: number;
    public feeShipVND?: number;
    public totalAmount?: number;
    public note?: string;
    public createdBy?: string;
    public createdDate?: string;
    public exportDate?: string;
    public noteForCustomer?: string;
};